<template>
    <!-- <div class="page"
        style="max-width: 600px; margin: 0 auto;height: 100%;background-size: 100% 100% ; background-image: url(./img/wj07.jpg);"> -->
    <div class="page" style="max-width: 600px; margin: 0 auto;height: 100%;background-size: 100% 100% ;">

        <div style="padding:15px">
            <el-tabs class="myTabs" v-model="type" @tab-click="onTabClick">
                <el-tab-pane label="场馆/场地预约" name="1"></el-tab-pane>
                <el-tab-pane label="课程预约" name="3"></el-tab-pane>
            </el-tabs>

            <div class="tm" v-if="dataList && dataList.length > 0">
                <div class="wjitem flexBetween" @click="goIvst(item)" v-for="(item, idx) in dataList">
                    <div class="wjtitle">{{ item.project_name }}</div>

                    <div class="wjdesc flexBetween">
                        {{ item.table_name }}
                        <!-- <span class="wjstatus" v-if="item.joined" style="color: #009900;margin-left:5px;">已预约</span>
                        <span class="wjstatus" style="color: orangered;margin-left:5px;" v-else>已取消</span> -->

                        <div class="righticon" style="margin-left:5px;">
                            <img :src="'./img/right.png'">
                        </div>
                    </div>

                </div>

            </div>
            <div v-else class="flexCenter">暂无预约数据哦~</div>
        </div>
    </div>
</template>

<script>

import { Buttons } from './button.js';
export default {
    data() {
        return {
            plan_id: 0,
            ivst_id: 0,
            planInfo: null,
            IvstInfo: null,
            dataList: [],
            color: ["1fa4fb", "3e6bff", "139efc", "149efc", "38aaf5", "2ea7f9", "3f6cfe", "109ffe", "4375ff"],
            tm0List: [],
            ckeckedXX: 0,
            step: 0,
            joined: false,
            openid: "",
            pmid: 0,
            type: '1',
        }
    },
    mounted() {
        // new Buttons({
        //     stickyRight: true, style: {
        //         top: '70vh',
        //         background:'#4096ff'
        //     }
        // })
        document.title = "我的预约"

        if (this.$route.query.openid && this.$route.query.type) {
            sessionStorage.setItem("openid", this.$route.query.openid);
            sessionStorage.setItem("pmid", this.$route.query.pmid);
            sessionStorage.setItem("type", this.$route.query.type);

            this.openid = this.$route.query.openid || ''
            this.pmid = this.$route.query.pmid || this.pmid
            if (this.$route.query.type == '1' || this.$route.query.type == '2') {
                this.type == '1'
            } else {
                this.type = this.$route.query.type || this.type
            }
            this.getList()
        }
    },
    methods: {
        getList() {
            this.$http.post("/api/myReverseList", {
                reserve_type: Number(this.type),
                openid: this.openid,
                pmid: this.pmid,
            }).then(res => {
                this.dataList = res.data.data
            })
        },
        onTabClick(tab, event) {
            this.getList()
        },
        goIvst(row) {
            let paramsrow = encodeURIComponent(JSON.stringify(row))
            this.$router.push("/h5_reserve_detail?openid=" + this.openid + "&id=" + row.id + "&row=" + paramsrow)
        },
        showToast(msg) {
            $("#toast").text(msg).show().animate({
                opacity: 1
            }, 200, "linear", function () {
                setTimeout(() => {
                    $("#toast").animate({
                        opacity: 0
                    }, "linear", 3000, function () {
                        $("#toast").hide()
                    })
                }, 2000)
            })
        },


    },
}
</script>
<style>
.myTabs .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
}
</style>
<style scoped>
.itemrow {
    font-size: 14px;
    padding: 10px;
    border-bottom: 1px solid #eee;
    position: relative;
}

.itemrow:active {
    background-color: #eee;
}

.right {
    width: 20px;
    height: 20px;

    position: absolute;
    top: 20px;
    right: 10px;
    background-image: url(../../../public/img/job-rightRow.png);
    background-size: cover;
}

.tm {
    border: 3px solid #0f9fff;
    margin-bottom: 20px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 3px 1px 1px #2226bc;

}

.stitem {
    width: 45%;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #1fa4fb;
    background-color: #1fa4fb;
}

.stitemckd {
    border: 2px solid #f9b379;
}

.stitem:nth-child(2n+1) {
    margin-right: 10%;
}

.bolder {
    font-weight: bolder;
}

.wjitem {
    border-bottom: 1px solid #eee;
    font-size: 14px;
    padding: 10px 15px;
    position: relative;
    border-radius: 10px;
}

.wjdesc {
    font-size: 12px;
    padding: 10px 0;
}

.wjstatus {
    /*float: right;*/
    margin-right: 10px;
    vertical-align: middle;
}

.wjtitle {
    margin-right: 30px;
}

.wjitem:active {
    background-color: #eee;
}

.righticon {
    width: 10px;
    height: 15px;
    /*position: absolute;*/
    /*top: 25px;*/
    /*right: 10px;*/
}

.righticon img {
    width: 100%;
    height: 100%;
}

.wjitem:nth-child(1) {
    border-top: 1px solid #eee;
}
</style>
